// 引入安装的axios插件
import axios from 'axios'

// let url = '/jqrsd'
let url = 'https://admin.xaojer.cn/jqrsd'
// let url = "http://192.168.2.118:8090/jqrsd"
// let url = "http://admin.xaojer.cn:8089/jqrsd"//正式库
// let url = "http://admin.xaojer.cn:8087/xiaojie"//测试库
const http = function (opt) {
  let _this = opt._this
  axios({
    method: opt.method,
    url: opt.url,
    data: opt.data,
    headers: opt.headers,
    withCredentials: true, // 运行跨域带上cookies
  }).then(res => {
    //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
    if (res.status == 200) {
      //这里我们只需要获取返回的data中的数据即可
      switch (res.data.code) {
        case 200:
          opt.success(res.data);
          break;
        case 1000:
          //_this.$Message.error('登陆失效，请重新登陆!');
          setTimeout(function () {
            _this.$router.push('/login')
          }, 1000);
          break;
        case 101: //登陆失效
          _this.$Message.error(res.data.error);
          break;
        case 500:
          _this.$Message.error(res.data.error);
          break;
        default:
          axios({
            method: "POST",
            url: url + "/login/whetherLogin",
            data: {},
            headers: opt.headers,
            withCredentials: true, // 运行跨域带上cookies
          }).then(res => {
            console.log('1111111111111')
            console.log(res)
            //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
            if (res.status == 200) {
              //这里我们只需要获取返回的data中的数据即可
              switch (res.data.code) {
                case 200:
                  if (res.data.user == "null") {
                    _this.$Message.error('登陆失效,请重新登陆!!!');
                    _this.$router.push('/login')
                  } else {
                   _this.$Message.error("系统错误,请联系管理员!!!");
                  }
                  break;
                default:
                 _this.$Message.error("系统错误,请联系管理员!!!");
                  break;
              }
            } else {
              _this.$Message.error('网络异常请检查你的网络!!!');
            }
          }).catch(err => {
            _this.$Message.error("系统错误,请联系管理员!!!");
          })
          break;
      }
    } else {
      opt._this.$Message.error('网络异常请检查你的网络!');
    }
  }).catch(err => {

    console.log(err)
    axios({
      method: "POST",
      url: url + "/login/whetherLogin",
      data: {},
      headers: opt.headers,
      withCredentials: true, // 运行跨域带上cookies
    }).then(res => {
      console.log('22222222222222')
      console.log(res)
      //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
      if (res.status == 200) {
        //这里我们只需要获取返回的data中的数据即可
        switch (res.data.code) {
          case 200:
            if (res.data.user == "null") {
              _this.$Message.error('登陆失效,请重新登陆!!!');
              _this.$router.push('/login')
            } else {
              _this.$Message.error("权限不够不能访问!!!");
            }
            break;
          default:
           _this.$Message.error("系统错误,请联系管理员!!!");
            break;
        }
      } else {
        opt._this.$Message.error('网络异常请检查你的网络!!!');
      }
    }).catch(err => {
      console.log("0000000000000")
      console.log(err)
      _this.$Message.error("系统错误,请联系管理员!!!");
    })

  })
}

const aaa = function (code, _this, error) {
  console.log(code)
  switch (code) {
    case 1000:
      _this.$Message.error('登陆失效，请重新登陆!');
      setTimeout(function () {
        _this.$router.push('/login')
      }, 1000);
      break;
    case 100:
      _this.$Message.error('服务器异常!');
      break;
    case 101:
      _this.$Message.error(error);
      break;
    case 500:
      _this.$Message.error(error);
      break;
    default:
      _this.$Message.error('服务器异常!');
      break;
  }
}
export default {
  http,
  url,
  aaa
}



// WEBPACK FOOTER //
// ./src/http/http.js